const initialState = {
    wrongCredentials: false,
    isLogin: false,
}

const adminAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN_ADMIN_SUCCESS':
            return { ...state, isLogin: true, wrongCredentials: false };
        case "LOGIN_ADMIN_ERROR":
            return {
                ...state,
                wrongCredentials: true,
                isLogin: false,
            }
        default:
            return state;
    }
}

export default adminAccountReducer;